import sendInteractionToGtm from '~/shared/gtm/sendInteractionToGtm';
import Toggle from './Toggle';
import useFunModeToggle from './useFunModeToggle';

const FunModeToggle: FC = () => {
  const { isFunMode, handleChange, leftLabel, rightLabel } = useFunModeToggle();
  return (
    <Toggle
      checked={Boolean(isFunMode)}
      onChange={handleChange}
      leftLabel={leftLabel}
      rightLabel={rightLabel}
      onClick={() =>
        sendInteractionToGtm({
          eventCategory: 'toggler_button',
          eventAction: 'Game_screen',
          eventLabel: isFunMode ? 'fun mode' : 'real mode',
        })
      }
    />
  );
};

export default FunModeToggle;
